// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__36ea0","large":"styles_large__2mR4O"};